import { VehiclePlace } from 'models/auto/vehicleSearch';

export const mapAirportVehiclePlace = (place: any, isCity?: boolean): VehiclePlace => {
  if ('isAirport' in place) return place;

  return {
    ...place,
    isAirport: isCity ? false : true,
  };
};
